export enum SOCKET_STATUS {
  NONE = 'none',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  RECONNECTING = 'reconnecting',
  CONNECTION_ERROR = 'connectionError',
  ERROR = 'error'
}

export enum TRANS {
  MAIN = 'main',
  SEO = 'seo',
}

export enum LOCALE {
  EN = 'en',
  RU = 'ru',
}
